"use strict";

angular.module("diceApp").component("diceCheck", {
  bindings: {
    value: "<"
  },
  templateUrl: "es6/base/check.html",
  controllerAs: "checkController"
});
